// The homepage's segments and the pages they open. Pure data (no React, no
// images) so the server's Markdown homepage can list the same links.
export const SEGMENT_PATHS = {
  crisis: "/solutions/crisis-negotiation",
  ransomware: "/solutions/ransomware-negotiation",
  police: "/solutions/police-departments",
  universities: "/solutions/universities",
} as const;

export type SegmentKey = keyof typeof SEGMENT_PATHS;
